import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { Success } from '../../assests/ExportImageIcon'
import './cruiseBookingConfirm.css'

// This file was an orphaned hotel-booking-confirmation mock (never wired to any route).
// Repurposed as the confirmation page for the cruise "Send Details" (/cruises/contact)
// flow. /cruises/contact now returns pnr/payment info (see CRUISE_BOOKING_CHANGES.md),
// shown below when present — falls back to a plain thank-you note otherwise.
// Original hotel mock kept below, commented out.
/*
const HOTEL_BOOKING = {
    bookingId: '#81245871271',
    name: 'Grand Luxury Hotel',
    rating: 5,
    location: 'Connaught Place, New Delhi',
    checkIn: { date: '06 Jun 2026, Sat', time: '12 PM' },
    checkOut: { date: '07 Jun, 2026, Sun', time: '11 AM' },
    nights: '1 Night',
    guestsRooms: '2 Adults • 1 Room',
}

const GUESTS = ['Birendra Kumar Chhotaray', 'Birendra Kumar Chhotaray']

const ROOM_BOOKING = {
    image: HotelSample,
    title: 'Deluxe Room',
    specs: [
        { icon: Sqaure, text: '280 sq ft' },
        { icon: Guest, text: '2 Guests' },
        { icon: Beds, text: '1 King Bed' },
    ],
    amenities: ['Swimming Pool', 'Golf', 'Bar'],
    planTitle: 'Room With Free Cancellation | Breakfast only',
    perks: [
        "10% off on session of 45 mins couple's Spa",
        'Early Check-In upto 3 hours (subject to availability)',
        '10% off on Food & Beverages with a-la-carte selection',
    ],
    refundStatus: 'No Refundable',
    refundNote: 'Refund is not applicable for this booking',
}

const GUEST_DETAILS = [
    { name: 'Shubham Modi', email: 'shubhammodi820@gmail.com', phone: '9024250272', ageGender: '26 • Male', guests: '2 Nights' },
    { name: 'Shubham Modi', email: 'shubhammodi820@gmail.com', phone: '9024250272', ageGender: '26 • Male', guests: '2 Nights' },
]

const PAYMENT_DETAILS = [
    { label: 'Base Fare', value: '₹3,599' },
    { label: 'Taxes & Fees', value: '₹450' },
    { label: 'Convenience Fee', value: '₹250' },
    { label: 'Seat Fare', value: '₹250' },
]

const PAYMENT_META = [
    { label: 'Payment Method', value: 'UPI' },
    { label: 'Transaction ID', value: 'UPI2026031512345678' },
    { label: 'Payment Date', value: 'March 14, 2026, 3:45 PM' },
]

const IMPORTANT_INFO = [
    'Carry a valid government-issued photo ID',
    'Print or save your boarding pass on mobile',
    'Check baggage allowance before packing',
    'Reach airport at least 2 hours before departure',
]

const GoldStar = () => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
        <path d="M7 10.65 2.89 12.95 3.8 8.33.34 5.13l4.68-.55L7 .29l1.98 4.29 4.68.55-3.46 3.2.92 4.62Z" fill="#F5A623" />
    </svg>
)

const HotelBookingConfirm = () => {
    return (
        <>
            <section className='bookingConfirm commonTopPadding commonBottomPadding'>
                <div className='container'>
                    <div className='row g-4'>
                        <div className='col-md-12'>
                            <div className='bookingTextConfirm'>
                                <img src={Success} />
                                <div className='bookingHead commonGredientText'>Booking Confirmed</div>
                                <p>Your hotel has been successfully booked</p>
                            </div>
                        </div>
                        <div className='col-md-12'>
                            <div className='bookingConfirmInner'>
                                <div className='resultCard'>
                                    <div className='bookingConfirmMetaLabel'>Booking ID <strong>{HOTEL_BOOKING.bookingId}</strong></div>

                                    <div className='hotelCard__topRow mt-3'>
                                        <div>
                                            <div className='hotelCard__name'>{HOTEL_BOOKING.name}</div>
                                            <div className='hotelCard__location mt-2'>
                                                <img src={Location} alt="" />
                                                <div className='hotelCard__locationName'>{HOTEL_BOOKING.location}</div>
                                            </div>
                                        </div>
                                        <div className='hotelCard__stars'>
                                            {Array.from({ length: HOTEL_BOOKING.rating }).map((_, index) => <GoldStar key={index} />)}
                                        </div>
                                    </div>

                                    <div className='bookingSegmentBox bookingInfoRow'>
                                        <div>
                                            <div className='bookingInfoLabel'>CHECK-IN</div>
                                            <div className='bookingInfoDate'>{HOTEL_BOOKING.checkIn.date}</div>
                                            <div className='bookingInfoTime'>{HOTEL_BOOKING.checkIn.time}</div>
                                        </div>
                                        <div className='bookingInfoNights'>— {HOTEL_BOOKING.nights} —</div>
                                        <div className='text-end'>
                                            <div className='bookingInfoLabel'>CHECK-OUT</div>
                                            <div className='bookingInfoDate'>{HOTEL_BOOKING.checkOut.date}</div>
                                            <div className='bookingInfoTime'>{HOTEL_BOOKING.checkOut.time}</div>
                                        </div>
                                    </div>

                                    <div className='bsFareRow mt-2'>
                                        <span>GUEST &amp; ROOMS</span>
                                        <span>{HOTEL_BOOKING.guestsRooms}</span>
                                    </div>

                                    <div className='bsSectionTitle mt-3'>Guests</div>
                                    <ul className='paymentTravellerList'>
                                        {GUESTS.map((guest, index) => (
                                            <li key={index}>{index + 1}. {guest}</li>
                                        ))}
                                    </ul>

                                    <div className='bookingConfirmActions'>
                                        <button type='button' className='bookingDownloadBtn'>View Booking</button>
                                        <button type='button' className='bookingShareBtn' aria-label="Share">
                                            <img src={Share} alt="" />
                                        </button>
                                    </div>
                                </div>

                                <div className='bsSection'>
                                    <div className='bsSectionTitle'>Room Details</div>
                                    <div className='bsBox'>
                                        <div className='roomBookingTop'>
                                            <span className='roomBookingImage'>
                                                <img src={ROOM_BOOKING.image} alt={ROOM_BOOKING.title} />
                                            </span>
                                            <div>
                                                <div className='hotelCard__name'>{ROOM_BOOKING.title}</div>
                                                <div className='roomBookingSpecs'>
                                                    {ROOM_BOOKING.specs.map((spec, index) => (
                                                        <span key={index}><img src={spec.icon} alt="" /> {spec.text}</span>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>

                                        <div className='roomBookingAmenities'>
                                            {ROOM_BOOKING.amenities.map((amenity) => (
                                                <span className='hotelCard__amenityPill' key={amenity}>{amenity}</span>
                                            ))}
                                        </div>

                                        <div className='roomBookingPlanTitle'>{ROOM_BOOKING.planTitle}</div>
                                        <div className='roomBookingPerks'>
                                            {ROOM_BOOKING.perks.map((perk, index) => (
                                                <div className='bookingBaggageItem' key={index}>
                                                    <img src={GreenTick} alt="" />
                                                    <span>{perk}</span>
                                                </div>
                                            ))}
                                        </div>

                                        <div className='bsFareDivider' />

                                        <div className='resultCard__airlineName'>{ROOM_BOOKING.refundStatus}</div>
                                        <div className='resultCard__flightNo'>{ROOM_BOOKING.refundNote}</div>
                                        <button type='button' className='bsCouponApply mt-2'>Inclusions &amp; Cancellation Policy</button>
                                    </div>
                                </div>

                                <div className='bsSection'>
                                    <div className='bsSectionTitle'>Guest Details</div>
                                    <div className='bsBox'>
                                        {GUEST_DETAILS.map((guest, index) => (
                                            <div className='bookingGuestCard' key={index}>
                                                <span className='bookingPassengerType'>GUEST {index + 1}</span>
                                                <div className='bookingGuestGrid'>
                                                    <div>
                                                        <div className='bookingConfirmMetaLabel'>Guest Name:</div>
                                                        <div className='bookingPassengerDetail'>{guest.name}</div>
                                                    </div>
                                                    <div>
                                                        <div className='bookingConfirmMetaLabel'>Email:</div>
                                                        <div className='bookingPassengerDetail'>{guest.email}</div>
                                                    </div>
                                                    <div>
                                                        <div className='bookingConfirmMetaLabel'>Phone Number:</div>
                                                        <div className='bookingPassengerDetail'>{guest.phone}</div>
                                                    </div>
                                                    <div>
                                                        <div className='bookingConfirmMetaLabel'>Age &amp; Gender:</div>
                                                        <div className='bookingPassengerDetail'>{guest.ageGender}</div>
                                                    </div>
                                                    <div>
                                                        <div className='bookingConfirmMetaLabel'>Guests:</div>
                                                        <div className='bookingPassengerDetail'>{guest.guests}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                <div className='bsSection'>
                                    <div className='bsSectionTitle'>Confirmation Sent</div>
                                    <div className='bsBox'>
                                        <p className='bookingConfirmSentText'>
                                            We&apos;ve sent your booking confirmation via email, SMS and WhatsApp.
                                        </p>
                                    </div>
                                </div>

                                <div className='bsSection'>
                                    <div className='bsSectionTitle'>Payment Details</div>
                                    <div className='bsBox'>
                                        {PAYMENT_DETAILS.map((item, index) => (
                                            <div className='bsFareRow' key={index}>
                                                <span>{item.label}</span>
                                                <span>{item.value}</span>
                                            </div>
                                        ))}
                                        <div className='bsFareRow bookingDiscountRow'>
                                            <span>Discount Applied</span>
                                            <span>- ₹250</span>
                                        </div>
                                        <div className='bsFareDivider' />
                                        <div className='bsFareRow bsFareRow--total'>
                                            <span>TOTAL AMOUNT</span>
                                            <span>₹4,299</span>
                                        </div>
                                        <div className='bsFareDivider' />
                                        {PAYMENT_META.map((item, index) => (
                                            <div className='bsFareRow' key={index}>
                                                <span>{item.label}</span>
                                                <span>{item.value}</span>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                <div className='bsSection'>
                                    <div className='bsSectionTitle'>Important Information</div>
                                    <div className='bsBox'>
                                        <ul className='bsInfoList'>
                                            {IMPORTANT_INFO.map((info, index) => (
                                                <li key={index}>{info}</li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </section>
        </>
    )
}
*/

const formatCruiseAmount = (value, currency) => {
    if (value === undefined || value === null || value === '') return null
    const amount = Number(value)
    if (Number.isNaN(amount)) return null
    const symbol = !currency || currency === 'INR' ? '₹' : `${currency} `
    return `${symbol}${amount.toLocaleString('en-IN')}`
}

const CruiseBookingConfirm = () => {
    const navigate = useNavigate()
    const location = useLocation()
    // /cruises/contact now returns pnr/payment info (see CRUISE_BOOKING_CHANGES.md) —
    // shown when present; falls back to the plain thank-you note if someone lands
    // here without that state (e.g. a direct link).
    const { pnr, paymentStatus, amount, currency } = location.state || {}
    const amountLabel = formatCruiseAmount(amount, currency)

    return (
        <section className='bookingConfirm cruiseBookingConfirmPage commonTopPadding commonBottomPadding'>
            <div className='container'>
                <div className='row g-4'>
                    <div className='col-md-12'>
                        <div className='bookingTextConfirm'>
                            <img src={Success} alt='' />
                            <div className='bookingHead commonGredientText'>
                                {pnr ? 'Booking Request Received' : 'Thanks for contacting us'}
                            </div>
                            <p>{pnr ? "We've received your booking request — our team will confirm it shortly." : 'We will contact you soon'}</p>
                            {/* <p className='bookingConfirmSentText mt-2'>
                                You will receive a call within 24 hours after submitting your information.
                            </p> */}
                        </div>
                    </div>

                    {pnr && (
                        <div className='col-md-12'>
                            <div className='bookingConfirmInner'>
                                <div className='resultCard'>
                                    <div className='bookingConfirmMetaLabel'>Booking Reference (PNR) <strong>{pnr}</strong></div>
                                    {paymentStatus && (
                                        <div className='bsFareRow mt-2'>
                                            <span>Payment Status</span>
                                            <span style={{ textTransform: 'capitalize' }}>{paymentStatus}</span>
                                        </div>
                                    )}
                                    {amountLabel && (
                                        <div className='bsFareRow bsFareRow--total'>
                                            <span>TOTAL AMOUNT</span>
                                            <span>{amountLabel}</span>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}

                    <div className='col-md-12 text-center'>
                        <button
                            type='button'
                            className='commonBtnTransparent mx-auto'
                            style={{ minWidth: 220, marginBottom: 12 }}
                            onClick={() => navigate('/profile', { state: { section: 'create-group' } })}
                        >
                            Create Splitwise Group
                        </button>
                        <button type='button' className='commonBtn mx-auto' style={{ minWidth: 220 }} onClick={() => navigate('/home')}>Back to Home</button>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default CruiseBookingConfirm
